import { Box, Icon } from '@bechtel/gds';
import { map } from 'lodash';
import { FC } from 'react';
import { navbarIcons } from '~/components';
import { ItemTextStyled, MoreOptionItem, NavLinkStyled } from '../styled';

export interface MoreOptionsItem {
  title: string;
  path: string;
  parentPath: string;
  editList?: string;
  id?: string;
  default?: boolean;
  browseList?: string;
}

interface MoreOptionsProps {
  items: MoreOptionsItem[];
  showMoreSelect: (item: MoreOptionsItem) => void;
}
export const MoreOptions: FC<MoreOptionsProps> = ({ items, showMoreSelect }) => {
  return (
    <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: '1' }}>
      {items.length &&
        map(items, (item) => {
          const CommoditiesIcon = navbarIcons[item.path];
          return (
            <NavLinkStyled to={`/${item.parentPath}/${item.path}`} key={item.path} onClick={() => showMoreSelect(item)}>
              <MoreOptionItem key={item.path}>
                {CommoditiesIcon ? (
                  <CommoditiesIcon />
                ) : (
                  <Icon icon="table-cells" iconStyle="duo" fillColor="primary.700" />
                )}
                <ItemTextStyled>{item.title}</ItemTextStyled>
              </MoreOptionItem>
            </NavLinkStyled>
          );
        })}
    </Box>
  );
};
